import { STATIC_OBS_URL } from '../../consts'

import './scroll-b.less'

const data = Array(21)
  .fill(0)
  .map((_, index) => ({
    src: `${STATIC_OBS_URL}/website/home/hezuo/a${index + 1}.png?v3`,
    title: `s${index + 1}`
  }))

interface ScrollBProps {
  className?: string
  style?: React.CSSProperties
}
export const ScrollB = (props: ScrollBProps) => {
  return (
    <div {...props} className={`scroll-b ${props?.className || ''}`}>
      <div className='inner-box scroll-to-left'>
        {data.map(item => {
          return (
            <div className='item' key={item.title}>
              <img alt={item.title} src={item.src} />
            </div>
          )
        })}
        {data.map(item => {
          return (
            <div className='item not-phone' key={item.title}>
              <img alt={item.title} src={item.src} />
            </div>
          )
        })}
      </div>
      <div className='inner-box scroll-to-right not-phone'>
        {data.map(item => {
          return (
            <div className='item' key={item.title}>
              <img alt={item.title} src={item.src} />
            </div>
          )
        })}
        {data.map(item => {
          return (
            <div className='item' key={item.title}>
              <img alt={item.title} src={item.src} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
